module.exports = __webpack_public_path__ + "4.3.2/img/workshop_4.f859349d.jpg";